import { render, staticRenderFns } from "./HazteSocio.vue?vue&type=template&id=d897acfa&scoped=true&"
import script from "./HazteSocio.vue?vue&type=script&lang=ts&"
export * from "./HazteSocio.vue?vue&type=script&lang=ts&"
import style0 from "./HazteSocio.vue?vue&type=style&index=0&id=d897acfa&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "d897acfa",
  null
  
)

export default component.exports